import { AppDownload } from '@pcln/vip'
import { Box } from 'pcln-design-system'

function AppDownloadWrapper() {
  return (
    <Box
      color='background.light'
      boxShadowSize='sm'
      borderRadius='xl'
      pr={[3, null, null, null, 4, 5]}
      pl={4}
    >
      <AppDownload gaTracking={() => {}} />
    </Box>
  )
}

export default AppDownloadWrapper
